import { Component, OnInit } from '@angular/core';
import * as cds from '@cds/core/icon';
import '@cds/core/icon/register.js';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import packageInfo from '../../package.json';
import { User } from './interfaces/user';
import { AuthService } from './services/authentication/auth.service';
import { UserService } from './services/user.service';
import { environment } from '../environments/environment';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
	title = 'be-product-catalog-front';
	userDetails: User;
	collapsible = true;
	collapse = false;
	opened = false;
	public appVersion;

	constructor(
		private readonly toastr: ToastrService,
		public userService: UserService,
		private readonly authService: AuthService,
		private readonly msalService: MsalService,
		private readonly msalBroadcastService: MsalBroadcastService
	) {
		cds.loadCoreIconSet();
		cds.loadEssentialIconSet();
		cds.loadCommerceIconSet();
		cds.loadMediaIconSet();
		cds.loadSocialIconSet();
		cds.loadTravelIconSet();
		cds.loadTextEditIconSet();
		cds.loadTechnologyIconSet();
		cds.loadChartIconSet();
		this.appVersion = packageInfo.version;
	}

	ngOnInit(): void {
		this.msalBroadcastService.inProgress$
			.pipe(filter((status: InteractionStatus) => status === InteractionStatus.None))
			.subscribe(() => {
				this.authService.initCurrentUser();
				const account = this.authService.currentAccount$.getValue();
				if (!account) {
					return;
				}

				// `InteractionStatus.None` can be emitted multiple times (e.g. after token acquisitions).
				// Only initialize the user/toast once per app session.
				if (this.userDetails) {
					return;
				}

				this.userService
					.setUserFromMsal(account)
					.then(() => {
						this.userDetails = this.userService.getUser();
						this.toastr.info(
							'MSAL session active',
							'Welcome back ' + (this.userDetails?.firstName ?? this.userDetails?.username)
						);
					})
					.catch((err) => console.warn('[AppComponent] Failed to initialize MSAL user', err));
			});
	}

	doLogout(): void {
		this.authService.logout();
	}

	async getJWTToken() {
		const account = this.authService.currentAccount$.getValue();
		if (!account) {
			return;
		}
		const result = await this.msalService.instance.acquireTokenSilent({
			scopes: environment.apiConfig.scopes,
			account
		});
		await navigator.clipboard.writeText(result.accessToken);
		this.toastr.info('JWT Token copied to clipboard');
	}
}
